var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 185,
    viewBox: "0 0 164 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.0967 59L145.82 184.96H0.373291L73.0967 59Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.44 18.0333C163.44 27.9928 155.366 36.0665 145.407 36.0665C135.447 36.0665 127.373 27.9928 127.373 18.0333C127.373 8.07369 135.447 0 145.407 0C155.366 0 163.44 8.07369 163.44 18.0333Z",
    fill: "#6843EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup11);
export default __webpack_public_path__ + "static/media/Group 1 (1).6fe41b5ae135a8b22f772c5684467fe1.svg";
export { ForwardRef as ReactComponent };